import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FieldArrayType, FieldType, FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { DialogService } from 'src/app/core/dialog.service';
import { isNullOrUndefined } from '../../../../app/core/utils';
import { PbProfileComponent } from 'src/app/pre-boarding/pb-profile/pb-profile.component';
import { Subject } from 'rxjs/internal/Subject';
import { DataService } from './data-service';
import { CommonService } from 'src/app/core/common.service';
import { MethodValidityService } from 'src/app/immigration/services/validations/method-validity.service';


@Component({
  selector: 'eos-array-picker',
  templateUrl: './array-picker.component.html',
  styleUrls: ['./array-picker.component.css']
})
export class ArrayPickerComponent extends FieldType implements OnInit {

  constructor(private modalService: NgbModal, public dataservice: DataService) {
    super();
  }
  buttonName: string = 'Update Details';
  countMessage: string = 'dependent';

  ngOnInit() {
    if (this.field.templateOptions.btnName) { this.buttonName = this.field.templateOptions.btnName }
    if (this.field.templateOptions.title == 'Vendor PO') {
      this.countMessage = 'vendor';
    }
    if (this.field.templateOptions.title == 'Previous Big Four Experience') {
      this.countMessage = 'experience';
    }
      if (this.field.templateOptions.title == 'Academic Qualifications') {
      this.countMessage = 'qualification';
    }
  }

  get count() {
    const value = isNullOrUndefined(this.field.formControl.value) || this.field.formControl.value === ''
      ? '{"formData":[]}' : this.field.formControl.value;

    const data = JSON.parse(value);
    if (data != null && data.formData != null) {
      return data.formData.length;
    }
    else {
      return 0;
    }

  }

  get hint() {
    return this.field.templateOptions.tooltip ? this.field.templateOptions.tooltip.content.toString() : '';
  }

  openPickerModel() {
    const picker = this.modalService.open(ArrayListInputComponent);

    picker.componentInstance.data =
      isNullOrUndefined(this.field.formControl.value) || this.field.formControl.value === ''
        ? '{"formData":[{}]}' : this.field.formControl.value;
    picker.componentInstance.isRequired = this.field.templateOptions.isRequired;
    picker.componentInstance.fieldSet = this.field.templateOptions.fieldsSet;
    picker.componentInstance.modalTitle = this.field.templateOptions.title;
    picker.componentInstance.formDisabled = this.formControl.disabled;
    picker.componentInstance.subTitle = this.field.templateOptions.subTitle;
    picker.componentInstance.immUserProfileView = this.field.templateOptions.immUserProfileView;
    picker.componentInstance.isIBM = this.field.templateOptions.isIBM;
    picker.componentInstance.nonDependent = this.field.templateOptions.nonDependent;
    picker.result.then(closeParam => {
      if (!isNullOrUndefined(closeParam)) {

        this.field.form.markAsDirty();
        this.field.formControl.patchValue(JSON.stringify(closeParam));
        if(this.field.templateOptions.isIBM){
          this.dataservice.changeData()
        }
      }
    }, dismiss => {

    });
  }

}


@Component({
  selector: 'array-list-input',
  template: `
  <div class="modal-header d-block">
    <div class="d-flex">
      <p class="modal-title"><strong>Update {{ modalTitle }} details</strong></p>
       <button type="button" (click)="close()" class="btn-close" aria-label="Close"></button>
    </div>
    <div class="modal-title" *ngIf="subTitle">  
    <div style="font-size:10px;" [innerHTML]="subTitle">
    </div>       
  </div>
  </div>
  <form [formGroup]="form"  class="mb-3">
    <formly-form [model]="model" [fields]="fields" [options]="options" [form]="form"></formly-form>
    <div class="d-flex justify-content-center" *ngIf="!formDisabled">
    <button class="btn btn-outline-primary me-2" (click)="close()">Close</button>

    <ng-template [ngIf]="!canEditCompleted">
    <button *ngIf="!this.immUserProfileView && !this.isIBM"  class="btn btn-secondary me-2" (click)="submit()" type="submit" [disabled]="!form.valid || (isRequired && model.formData && model.formData.length == 0)">Update</button>
    <button *ngIf=this.isIBM class="btn btn-secondary me-2" (click)="submit()" type="submit" [disabled]="!form.valid || (isRequired && model.formData && model.formData.length == 0)">Save</button>
    </ng-template>         

    <button *ngIf="canEditCompleted" class="btn btn-secondary me-2" (click)="submit()" type="submit" [disabled]="(isRequired && model.formData && model.formData.length == 0)">Save completed</button>

    </div>
  </form>
   <!--{{model | json}}-->
    `,
})
export class ArrayListInputComponent implements OnInit {
  @Input() data: any;
  @Input() fieldSet: FormlyFieldConfig[];
  @Input() modalTitle: string;
  @Input() formDisabled: boolean = false;
  @Input() form = new UntypedFormGroup({});
  @Input() isRequired: boolean = false;
  @Input() subTitle: string;
  @Input() immUserProfileView: boolean = false;
  @Input() nonDependent: boolean = false;
  @Input() isIBM: boolean = false;
  canEditCompleted : boolean;
  
  model = {
    formData: [
    ],
  };
  options: FormlyFormOptions = {};

  fields: FormlyFieldConfig[] = [];

  constructor(public modal: NgbActiveModal,
    private dialog: DialogService,private common:CommonService, private validations: MethodValidityService) { }

  ngOnInit() {
    this.fields = this.fieldSet;
    this.canEditCompleted = this.common.caneditCompletedProfile;
    if (this.formDisabled) {
      this.form.disable();
    }
    this.initializeData();
    // if(this.modalTitle=='Vendor PO'){
    //   this.subTitle=true;
    //   }

  }

  ngAfterViewInit() {

    this.initializeData();
  }

  initializeData() {

    const dateFields = ["poReceivedDate", "poRequestedDate", "poSharedDate",
      "invoiceReceivedDate", "passportExpiryDate", "dateOfBirth",
      "visaIssuanceDate", "visaCancellationDate","visaExpiryDate", "rpIssuanceDate",
      "rpExpiryDate", "dateOfTravel", "cprExpiryDate",
      "civilIdExpiryDate", "bigFourstartDate", "bigFourendDate","attestationCompletedDate",
    "dateServiceRequested","poRequestedByOB","awsApprovalDate",
    "procurementApprovalDate","engagementCodeOwnerApprovalDate",
    "datePOSharedWithPJC","invoiceSentToOBAndFinance" 
    ]
    const parsedData = JSON.parse(this.data, (key, value) => {
      if (key && dateFields.includes(key)) {
        return value?.replace('Z', '');
      }
      return value
    });



    if (parsedData.formData != null) {
      parsedData.formData.forEach(item => {

        item.poRequestedDate = isNullOrUndefined(item.poRequestedDate) ? null : new Date(item.poRequestedDate);
        item.poReceivedDate = isNullOrUndefined(item.poReceivedDate) ? null : new Date(item.poReceivedDate);
        item.poSharedDate = isNullOrUndefined(item.poSharedDate) ? null : new Date(item.poSharedDate);
        item.invoiceReceivedDate = isNullOrUndefined(item.invoiceReceivedDate) ? null : new Date(item.invoiceReceivedDate);
        item.passportExpiryDate = isNullOrUndefined(item.passportExpiryDate) ? null : new Date(item.passportExpiryDate);
        item.dateOfBirth = isNullOrUndefined(item.dateOfBirth) ? null : new Date(item.dateOfBirth);
        item.visaIssuanceDate = isNullOrUndefined(item.visaIssuanceDate) ? null : new Date(item.visaIssuanceDate);
        item.visaCancellationDate = isNullOrUndefined(item.visaCancellationDate) ? null : new Date(item.visaCancellationDate);
        item.visaExpiryDate = isNullOrUndefined(item.visaExpiryDate) ? null : new Date(item.visaExpiryDate);
        item.rpIssuanceDate = isNullOrUndefined(item.rpIssuanceDate) ? null : new Date(item.rpIssuanceDate);
        item.rpExpiryDate = isNullOrUndefined(item.rpExpiryDate) ? null : new Date(item.rpExpiryDate);
        item.dateOfTravel = isNullOrUndefined(item.dateOfTravel) ? null : new Date(item.dateOfTravel);
        item.cprExpiryDate = isNullOrUndefined(item.cprExpiryDate) ? null : new Date(item.cprExpiryDate);
        item.civilIdExpiryDate = isNullOrUndefined(item.civilIdExpiryDate) ? null : new Date(item.civilIdExpiryDate);
        item.bigFourstartDate = isNullOrUndefined(item.bigFourstartDate) ? null : new Date(item.bigFourstartDate);
        item.bigFourendDate = isNullOrUndefined(item.bigFourendDate) ? null : new Date(item.bigFourendDate);
        item.serviceCompleted = isNullOrUndefined(item.serviceCompleted) ? null : item.serviceCompleted;
        item.attestationCompletedDate = isNullOrUndefined(item.attestationCompletedDate) ? null : new Date(item.attestationCompletedDate);
        item.dateServiceRequested = isNullOrUndefined(item.dateServiceRequested) ? null : new Date(item.dateServiceRequested);
        item.poRequestedByOB = isNullOrUndefined(item.poRequestedByOB) ? null : new Date(item.poRequestedByOB);
        item.awsApprovalDate = isNullOrUndefined(item.awsApprovalDate) ? null : new Date(item.awsApprovalDate);
        item.procurementApprovalDate = isNullOrUndefined(item.procurementApprovalDate) ? null : new Date(item.procurementApprovalDate);
        item.engagementCodeOwnerApprovalDate = isNullOrUndefined(item.engagementCodeOwnerApprovalDate) ? null : new Date(item.engagementCodeOwnerApprovalDate);
        item.datePOSharedWithPJC = isNullOrUndefined(item.datePOSharedWithPJC) ? null : new Date(item.datePOSharedWithPJC);
        //item.datePOSharedWithVendor = isNullOrUndefined(item.datePOSharedWithVendor) ? null : new Date(item.datePOSharedWithVendor);
        item.invoiceSentToOBAndFinance = isNullOrUndefined(item.invoiceSentToOBAndFinance) ? null : new Date(item.invoiceSentToOBAndFinance);


      });
    }
    this.model = parsedData;
  }
  submit() {
    // let duplicateDOB: boolean = false;
    // let dob = {};
    let duplicateEntry: boolean = false;
    let uniqueEntries = {};
    if (this.fields[0].formControl.valid) {
      this.model.formData.forEach(item => {
        this.setToUtcDate(item?.poRequestedDate);
        this.setToUtcDate(item?.poReceivedDate);
        this.setToUtcDate(item?.poSharedDate);
        this.setToUtcDate(item?.invoiceReceivedDate);
        this.setToUtcDate(item?.passportExpiryDate)
        this.setToUtcDate(item?.dateOfBirth)
        this.setToUtcDate(item?.visaIssuanceDate)
        this.setToUtcDate(item?.visaCancellationDate);
        this.setToUtcDate(item?.visaExpiryDate)
        this.setToUtcDate(item?.rpIssuanceDate)
        this.setToUtcDate(item?.rpExpiryDate)
        this.setToUtcDate(item?.dateOfTravel)
        this.setToUtcDate(item?.cprExpiryDate)
        this.setToUtcDate(item?.civilIdExpiryDate)
        this.setToUtcDate(item?.bigFourstartDate)
        this.setToUtcDate(item?.bigFourendDate)
        this.setToUtcDate(item?.attestationCompletedDate)
        this.setToUtcDate(item?.dateServiceRequested)
        this.setToUtcDate(item?.poRequestedByOB)
        this.setToUtcDate(item?.awsApprovalDate)
        this.setToUtcDate(item?.procurementApprovalDate)
        this.setToUtcDate(item?.engagementCodeOwnerApprovalDate)
        this.setToUtcDate(item?.datePOSharedWithPJC)
        //this.setToUtcDate(item?.datePOSharedWithVendor)
        this.setToUtcDate(item?.invoiceSentToOBAndFinance)

        //let dateOfBirth;

        // if (!isNullOrUndefined(item?.dateOfBirth)) {
        //   dateOfBirth = new Date(item?.dateOfBirth).setHours(0, 0, 0, 0);

        //   if (!dob[dateOfBirth]) {
        //     dob[dateOfBirth] = 1;
        //   } else {
        //     dob[dateOfBirth]++;
        //     duplicateDOB = true;
        //   }
        // }
          if (!isNullOrUndefined(item?.dateOfBirth) && !isNullOrUndefined(item?.firstName) && !isNullOrUndefined(item?.lastName)) {
            let dateOfBirth = new Date(item.dateOfBirth).setHours(0, 0, 0, 0);
            let fullName = (item.firstName + ' ' + item.lastName).toLowerCase();
            let uniqueId = dateOfBirth + '_' + fullName; // Create a unique identifier
        
            if (!uniqueEntries[uniqueId]) {
              uniqueEntries[uniqueId] = 1;
            } else {
              uniqueEntries[uniqueId]++;
              duplicateEntry = true;
            }
          }
      });
    }

    // if (duplicateDOB) {
    //   this.dialog.showConfirmationBox("", 'A dependent with the same date of birth already exists, by clicking “OK” you are confirming that is a different dependent with the same date of birth',
    //     () => {
    //       this.submitData();
    //     });
    // }
    if (duplicateEntry) {
      this.dialog.showPopUpMessage('A dependent with the same Date of Birth /First name/ Last name already exists. Please verify the information.', () => {
      });
    }
    else if(this.canEditCompleted){
      let formArray = this.fields[0].formControl as UntypedFormArray; 
      const { invalid, ignored } = this.validations.validateCompletedSubmit(formArray);
      if(invalid.length > 0){
        return;
      }
      if(ignored.length > 0){
        let finalMessage = this.common.uniqueByPropertyName(ignored).join('<br/>') + '. ';
      this.dialog.showConfirmationBox( "Confirm dates" ,`The below dates on this request are either past dates or do not meet the validation criteria. Please confirm if you would still like to proceed with saving the changes on this request<br>` + finalMessage
        ,()=>{
          this.submitData();
        }
        ,()=>{return;} , null, false
        );
      }
      else{
        this.submitData();
      }
    }
    else {
      this.submitData();
    }
  }

  submitData() {
    if (this.fields[0].formControl.valid || this.canEditCompleted) {
      if (this.nonDependent) {
        this.modal.close(this.model);
        
      }
      else {
        // alert is only needed for dependents added in immigration
        // excluded : vendor po, big four,emp profile, dependent popup in PJ
        this.dialog.showPopUpMessage(`Please note that adding/deleting a new dependent on this request does not automatically add/delete this dependent to your TMT employee profile. 
        Therefore, please ensure you add/delete them on your employee profile once the request is completed (if required).`, () => {
          this.modal.close(this.model);
        });
      }
    }
  }


  close() {
    this.modal.close();
    //Edit access to IBM team members to update the details in the Vendor PO details tab.
    
  }

  setToUtcDate(date: Date) {
    if (!isNullOrUndefined(date)) {
      date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    }
  }

}


@Component({
  selector: 'formly-repeat-section',
  template: `
<div class="d-flex flex-column">
<div *ngFor="let field of field.fieldGroup; let i = index;" class="row m-0 border-bottom">
    <formly-field class="col" [field]="field"></formly-field>
    <div *ngIf=!to.immUserProfileView class="col-md-2 d-flex align-items-center">
        <button class="btn btn-danger btn-sm" type="button" (click)="remove(i)" title="Click delete button to remove dependent" >Delete</button>
    </div>
</div>
</div>
<div class="d-flex justify-content-end pe-5">
<button *ngIf=!to.immUserProfileView class="btn btn-outline-primary m-2" type="button" (click)="add()">{{ to.addText }}</button>
</div>
  `,
})
export class RepeatTypeComponent extends FieldArrayType implements OnInit {

  constructor() {
    super();
  }
  ngOnInit() {
    // console.log(this.field)
  }
}

@Component({
  selector: 'formly-repeat-range-section',
  template: `
<div class="d-flex flex-column">
<div *ngFor="let field of field.fieldGroup; let i = index;" class="row m-0 border-bottom">
    <formly-field class="col" [field]="field"></formly-field>
    <div *ngIf=!to.immUserProfileView class="col-md-2 d-flex align-items-center">
        <button class="btn btn-danger btn-sm" type="button" (click)="remove(i)" title="Click delete button to remove dependent" >Delete</button>
    </div>
</div>
</div>
<div class="d-flex justify-content-end pr-5" *ngIf="this.field.formControl.value.length<to.maxLength" >
<button *ngIf=!to.immUserProfileView class="btn btn-outline-primary m-2" type="button"  (click)="add()">{{ to.addText }}</button>
</div>
  `,
})
export class RepeatRangeTypeComponent extends FieldArrayType implements OnInit {

  constructor() {
    super();
  }

  ngOnInit() {
  }

}
